import axios from 'axios'

export const BaseUrl = "https://tphc.transformperform.ca/thpc/api/"

//  instance of axios with a custom config
export const httpRequest = axios.create({
    baseURL: 'https://tphc.transformperform.ca/thpc/api/',
})
